import { render, staticRenderFns } from "./showauditlogs.vue?vue&type=template&id=11cf617e&"
import script from "./showauditlogs.vue?vue&type=script&lang=ts&"
export * from "./showauditlogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "showauditlogs.vue"
export default component.exports